"use client";

import { FaWhatsapp } from "react-icons/fa";
import { motion } from "framer-motion";

const FloatingContactButton = () => {
  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2, type: 'spring' }}
      className="fixed bottom-8 right-6 z-[450] flex flex-col items-end gap-3 group"
    >
      {/* Tooltip */}
      <div className="bg-[#C8A96E] text-[#0F172A] px-4 py-2 text-[10px] font-bold tracking-widest opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap" style={{ fontFamily: 'var(--font-space-mono, "Space Mono", monospace)' }}>
        FREE CONSULTATION
      </div>
      
      <a
        href="https://wa.me/918800899170"
        target="_blank"
        rel="noopener noreferrer"
        className="relative bg-green-510 bg-[#25D366] text-white rounded-full p-5 shadow-[0_0_20px_rgba(37,211,102,0.3)] hover:scale-110 transition-transform active:scale-95"
        aria-label="Chat on WhatsApp"
      >
        <motion.div
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="absolute inset-0 rounded-full bg-[#25D366]/40 -z-10"
        />
        <FaWhatsapp size={32} />
      </a>
    </motion.div>
  );
};

export default FloatingContactButton;
